var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPersonalCare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.248 13.333C10.5239 13.333 10.7971 13.3904 11.0498 13.501L14.8418 15.1602C15.4828 15.4408 15.7776 16.1859 15.502 16.8291C15.4601 16.9267 15.4071 17.0167 15.3457 17.0977L17.1553 18.2441C17.7107 18.5219 18.3234 18.667 18.9443 18.667H20C20.7364 18.667 21.333 19.2636 21.333 20C21.333 20.7364 20.7364 21.333 20 21.333H14.5928C13.7648 21.333 12.9476 21.1408 12.207 20.7705L9.33301 19.333V13.333H10.248ZM17.9658 10.667C18.3077 10.667 18.6362 10.8022 18.8779 11.0439C19.1296 11.2956 19.5374 11.2956 19.7891 11.0439C20.0307 10.8024 20.3585 10.6671 20.7002 10.667H20.8984C21.8747 10.667 22.667 11.4583 22.667 12.4346V12.5176C22.667 12.9378 22.5232 13.3457 22.2607 13.6738L20.8955 15.3809C20.0949 16.3817 18.5721 16.3817 17.7715 15.3809L16.4053 13.6738C16.1428 13.3457 16 12.9378 16 12.5176V12.4346C16 11.4583 16.7914 10.6671 17.7676 10.667H17.9658Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPersonalCare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/personal_care.65642331a3f28f85a652be7fd2f01eaa.svg";